import { Component, Input, OnInit } from '@angular/core';
import { Param } from 'src/app/widgets';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.css']
})
export class CardsComponent implements OnInit {
  @Input() contentJSON: any;
  @Input() environmentJSON: any;

  constructor() { }

  ngOnInit(): void {
  }

  trackByFn(index, item) {
    return index;
  }
}
